import * as Yup from 'yup';

/** @constant {ObjectShape} - Yup Object used for validationScheme in signup procedure */
const IncidentScheme = Yup.object().shape({
  // status: [false, true],
  title: Yup.string()
    .trim()
    .min(5, 'Title must be at least 5 characters')
    .required('Incident title is required'),
  business_owner: Yup.string().trim().required('Business owner is required'),
  // assigned_to: Yup.string().required('Assign to is required'),
});

export { IncidentScheme };
